import { DropResult } from 'react-beautiful-dnd';

import { loadableDataActions } from '../../../common/utils/LoadableData';
import { ApiResultOfListOfCustomCostObjectiveDTO, BaseSearch } from '../../../services/types/ApiTypes';
import api from '../../../services/ApiServices';
import { DispatchThunk } from '../../../storeConfig';

const ns = 'settings/accounting/';

export const loadCostObjectivesLoadableActions = loadableDataActions<BaseSearch, ApiResultOfListOfCustomCostObjectiveDTO>(`${ns}LOAD_COST_OBJECTIVES`);

export function loadCostObjectives() {
    return async (dispatch: DispatchThunk) => {
        let response;
        try {
            dispatch(loadCostObjectivesLoadableActions.request(undefined));
            response = await api.customCostObjective.getCompanyCustomCostObjectivesWithoutDimensions();
            dispatch(loadCostObjectivesLoadableActions.success(response.data));
        } catch (e) {
            console.error(e);
            dispatch(loadCostObjectivesLoadableActions.error(e));
        }
    };
}

export const reorderCostObjectiveLoadableActions = loadableDataActions<DropResult, any>(`${ns}REORDER_COST_OBJECTIVE`);

export function reorderCostObjective(result: DropResult) {
    const costObjectiveId = Number(result.draggableId);
    const newOrderNo = result.destination.index + 1;

    return async (dispatch: DispatchThunk) => {
        let response;
        try {
            dispatch(reorderCostObjectiveLoadableActions.request(result));
            response = await api.customCostObjective.updateCustomCostObjectiveOrderNumber(costObjectiveId, newOrderNo);
            dispatch(reorderCostObjectiveLoadableActions.success(response.data));
        } catch (e) {
            console.error(e);
            dispatch(reorderCostObjectiveLoadableActions.error(e));
            dispatch(loadCostObjectives());
        }
    };
}
